import React from "react";

const Clip = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.00065 18.0002C5.41732 18.0002 3.75065 17.4168 2.58398 16.1668C0.167318 13.7502 0.167318 9.75016 2.58398 7.25016L6.33398 3.50016C6.66732 3.16683 7.25065 3.16683 7.66732 3.50016C8.00065 3.8335 8.00065 4.41683 7.66732 4.8335L3.91732 8.5835C2.16732 10.3335 2.16732 13.1668 3.91732 14.8335C5.66732 16.5835 8.50065 16.5835 10.1673 14.8335L16.6673 8.3335C17.6673 7.3335 17.6673 5.5835 16.6673 4.5835C15.6673 3.5835 13.9173 3.5835 12.9173 4.5835L7.00065 10.5002C6.66732 10.8335 6.66732 11.4168 7.00065 11.7502C7.33398 12.0835 7.91732 12.0835 8.25065 11.7502L12.2507 7.75016C12.584 7.41683 13.1673 7.41683 13.584 7.75016C13.9173 8.0835 13.9173 8.66683 13.584 9.0835L9.58398 13.0835C8.41732 14.1668 6.66732 14.1668 5.66732 13.0835C4.58398 12.0002 4.58398 10.3335 5.66732 9.25016L11.584 3.3335C13.334 1.5835 16.1673 1.5835 17.9173 3.3335C19.6673 5.0835 19.6673 7.91683 17.9173 9.66683L11.4173 16.1668C10.2507 17.3335 8.66732 18.0002 7.00065 18.0002Z"
        fill="#66D2B8"
      />
    </svg>
  );
};

export default Clip;
